// extracted by css-extract-rspack-plugin
export default {"box":"wcQZcnJbPKUgWkgR","btn":"RFCyP9500oU7kopT","active":"bQ0W01wcXsmiF5kA"};